import React from 'react';
import { translate } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPaper, faBolt } from '@fortawesome/pro-solid-svg-icons';
import { classes } from './styles/table';

class ActiveCellComponent extends React.Component {

  render() {
    const { t, value } = this.props;
    return (
      <React.Fragment>
        <span className={classes.icon}>
          <FontAwesomeIcon icon={value ? faBolt : faHandPaper} />
        </span>
        {t(value ? 'table.active' : 'table.inactive')}
      </React.Fragment>
    )
  }

}

export default translate(['comm'])(ActiveCellComponent);


// WEBPACK FOOTER //
// ./src/views/comm/active-cell.js